import { PermEnum } from './perm-enum'
import { RoleReflection } from './role-reflection'

export interface RoleInterface {
  schoolId: number
  /**
   * 角色关联权限集合
   */
  perms?: PermEnum[]
  /**
   * 名称
   */
  name: string
  /**
   * 描述
   */
  description?: string
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 角色关联的用户
   */
  reflections?: RoleReflection[]
  default?: boolean
  /**
   * 主键 ID
   */
  id: number
}

export class Role implements RoleInterface {
  schoolId: number
  /**
   * 角色关联权限集合
   */
  perms?: PermEnum[]
  /**
   * 名称
   */
  name: string
  /**
   * 描述
   */
  description?: string
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 角色关联的用户
   */
  reflections?: RoleReflection[]
  default?: boolean
  /**
   * 主键 ID
   */
  id: number

  constructor(props: RoleInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      schoolId: _schoolId,
      perms: _perms,
      name: _name,
      description: _description,
      createdAt: _createdAt,
      reflections: _reflections,
      default: _default,
      id: _id,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.schoolId = _schoolId
    this.perms = _perms
    this.name = _name
    this.description = _description
    this.createdAt = _createdAt
    this.reflections = _reflections
      ? _reflections.map((i) => new RoleReflection(i))
      : _reflections
    this.default = _default
    this.id = _id
  }
}
